import React from "react";
import { InputSwitch } from "primereact/inputswitch";

/**
 * Propriedades para o componente `PermissionTypeSwitch`.
 */
interface PermissionTypeSwitchProps {
  /** O ID da permissão (atualmente não utilizado, mas mantido para referência). */
  permissionId: string | undefined;
  /** O valor booleano a ser exibido pelo switch. */
  value: boolean;
}

/**
 * Componente de visualização que renderiza um `InputSwitch` desabilitado.
 * É utilizado no corpo das colunas booleanas do `DataTable` para exibir o estado (true/false) de uma permissão.
 * @param {PermissionTypeSwitchProps} props - As propriedades do componente.
 */
const PermissionTypeSwitch: React.FC<PermissionTypeSwitchProps> = ({
  value,
}) => {
  return (
    <div>
      <InputSwitch
        checked={value}
        disabled // O switch na grelha é apenas para visualização
      />
    </div>
  );
};

export default PermissionTypeSwitch;
